import type { JSX, ReactNode } from 'react';
import { Page } from '@/component/Layout';
import { LayoutProvider, useLayout } from './LayoutContext';
import { MultiPanelLayout } from './MultiPanelLayout';
import { StackLayout } from './StackLayout';
import type { LayoutBreakpoints, LayoutMode } from './types';

export type ContentType = 'main' | 'aside';

interface LayoutProps {
  list: ReactNode;
  main: ReactNode;
  breakpoints: LayoutBreakpoints;
  domain?: string;
}

export const Layout = ({ list, main, breakpoints, domain }: LayoutProps) => {
  return (
    <LayoutProvider breakpoints={breakpoints} domain={domain}>
      <LayoutRenderer list={list} main={main} />
    </LayoutProvider>
  );
};

export interface LayoutModeProps extends Omit<LayoutProps, 'breakpoints'> {}

const modes: Record<LayoutMode, (props: LayoutModeProps) => JSX.Element> = {
  'multi-panel': MultiPanelLayout,
  stack: StackLayout,
};

const LayoutRenderer = ({ list, main }: LayoutModeProps) => {
  const { layout } = useLayout();
  const LayoutComponent = modes[layout];

  return (
    <Page>
      <LayoutComponent list={list} main={main} />
    </Page>
  );
};
